export function createPasswordValidator(specialCharacters: string[]) {
  function validateTooShort(fieldValue: string) {
    return fieldValue.trim().length >= 8
  }

  function validateNoNumbers(fieldValue: string) {
    return !/\d/.test(fieldValue)
  }

  function validateNoUppercaseLetter(fieldValue: string) {
    return !/[A-Z]/.test(fieldValue)
  }

  function validateNoLowercaseLetter(fieldValue: string) {
    return !/[a-z]/.test(fieldValue)
  }

  function validateNoSpecialCharacter(fieldValue: string) {
    return !new RegExp(`[\\${specialCharacters.join('\\')}]`).test(fieldValue)
  }

  return {
    validateTooShort,
    validateNoNumbers,
    validateNoUppercaseLetter,
    validateNoLowercaseLetter,
    validateNoSpecialCharacter,
  }
}
